module.exports = __webpack_public_path__ + "img/306cabbf82bcc1f7eb3db28f52b917e5.png";